var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('perseo-tabla-avanzada',{attrs:{"datos":_vm.arrayLineas,"columnas":_vm.columnas,"seleccionable":false,"mostrar-acciones":false,"items-por-pagina-inicial":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }